import React, { Component } from 'react';

import styles from './TinybopSchoolsMaterials.scss';

class MammalsMaterials extends Component {
  render() {
    return (
      <div className="TinybopSchoolsMaterials">
        <a
          className="TinybopSchoolsMaterials__handbook"
          href="https://schools-cdn.tinybop.com/assets/handbooks/en/tinybop-mammals-handbook.pdf"
          target="_blank"
        >
          <img
            className="TinybopSchoolsMaterials__handbook-icon"
            src="https://schools.tinybop.com/assets/components/GameHandbook/handbook-thumb-mammals.png"
            alt="Mammals Handbook Cover"
          />
          <div className="TinybopSchoolsMaterials__handbook-text">
            <p>
              <strong>MAMMALS HANDBOOK</strong>
            </p>
            <p>
              Look to the handbook for supplementary information, interaction
              hints, questions, and answers.
            </p>
            <p className="TinybopSchoolsMaterials__link">VIEW</p>
          </div>
        </a>

        <div className="TinybopSchoolsMaterials__links">
          <a
            href="https://schools-cdn.tinybop.com/assets/printables/TinybopSchoolsPrintables_Mammals_AnimalDiets.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Animal Diets: As You Play
          </a>
          <a
            href="https://schools-cdn.tinybop.com/assets/printables/TinybopSchoolsPrintables_Mammals_MammalBodySystems.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Mammal Body Systems: As You Play
          </a>
          <a
            href="https://schools-cdn.tinybop.com/assets/printables/TinybopSchoolsPrintables_General_GeneratingQuestions.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Generating Questions: As You Play
          </a>
          <a
            href="https://schools-cdn.tinybop.com/assets/printables/TinybopSchoolsPrintables_General_ConceptMap.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Concept Map: As You Play
          </a>
        </div>
      </div>
    );
  }
}

export default MammalsMaterials;
